export const GET_TABLE_ROW_TEST_ID = (rowId: string) => `table-row-${rowId}`
